import { Sparkle } from "lucide-react";

export function IllustrativeBadge({ className = "" }) {
  return (
    <span
      data-testid="illustrative-badge"
      className={`inline-flex items-center gap-1.5 rounded-full border border-dashed border-stone-400 bg-mill-alt/70 px-2.5 py-1 text-[11px] font-medium uppercase tracking-[0.14em] text-mill-muted ${className}`}
    >
      <Sparkle className="h-3 w-3" />
      Illustrative — synthetic data
    </span>
  );
}
